import { render, staticRenderFns } from "./transferModal.vue?vue&type=template&id=b9c0a734&scoped=true"
import script from "./transferModal.vue?vue&type=script&lang=js"
export * from "./transferModal.vue?vue&type=script&lang=js"
import style0 from "./transferModal.vue?vue&type=style&index=0&id=b9c0a734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c0a734",
  null
  
)

export default component.exports